import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Select, MenuItem, FormControl, InputLabel, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Alert, Box } from "@mui/material";


import './index.css';
import img0 from '../../../src/images/Filter.svg';
import img1 from '../../../src/images/Ai.svg';
import img2 from '../../../src/images/Profile.svg';
import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img12 from '../../../src/images/Icon (6).svg';
import img14 from '../../../src/images/patient-icon.svg'; // Patients Icon
import config from '../../config/config';

function AppointmentsPage() {
    const navigate = useNavigate();
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);

    const [patientsData, setPatientsData] = useState([]); // To store data from /api/patients
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [filters, setFilters] = useState({
        timeRange: '',
        appointmentType: '',
        patientPriority: '',
        appointmentStatus: '',
        visitType: '',
    });
    const [showFilters, setShowFilters] = useState(false);
    const [currentFilterKey, setCurrentFilterKey] = useState(null);
    const backendURL = `${config.backendServerHost}`;
    const location = useLocation();
    const { patientName, patientAge, patientCondition, groomingProgress, appointmentDate, appointmentTimeslot } =
    location.state || {}; // Extract properties from state directly
    const [groomingStatuses, setGroomingStatuses] = useState({});

    const filterOptions = {
        timeRange: ['Today', 'This Week', 'This Month'],
        appointmentType: ['Check-Up', 'Follow-Up', 'Consultation'],
        patientPriority: ['High', 'Medium', 'Low'],
        appointmentStatus: ['Scheduled', 'Rescheduled', 'Cancelled'],
        visitType: ['In-Person', 'Virtual'],
    };

    useEffect(() => {
        fetch(`${backendURL}/patients/api/appointments`)
            .then((res) => res.json())
            .then((data) => {
                setAppointments(data);
                applyFilters(data, filters);
            });
    }, [filters, backendURL]); // Add backendURL to dependencies

    const applyFilters = (appointmentsData, appliedFilters) => {
        let filtered = appointmentsData;

        if (appliedFilters.timeRange) {
            const today = new Date();
            filtered = filtered.filter((appointment) => {
                const appointmentDate = new Date(appointment.date);

                if (appliedFilters.timeRange === 'Today') {
                    return appointmentDate.toDateString() === today.toDateString();
                }

                if (appliedFilters.timeRange === 'This Week') {
                    const weekStart = new Date(today.setDate(today.getDate() - today.getDay()));
                    const weekEnd = new Date(weekStart);
                    weekEnd.setDate(weekStart.getDate() + 6);
                    return appointmentDate >= weekStart && appointmentDate <= weekEnd;
                }

                if (appliedFilters.timeRange === 'This Month') {
                    return (
                        appointmentDate.getMonth() === today.getMonth() &&
                        appointmentDate.getFullYear() === today.getFullYear()
                    );
                }

                return true;
            });
        }

        if (appliedFilters.appointmentType) {
            filtered = filtered.filter((appointment) => appointment.type === appliedFilters.appointmentType);
        }

        if (appliedFilters.patientPriority) {
            filtered = filtered.filter((appointment) => appointment.priority === appliedFilters.patientPriority);
        }

        if (appliedFilters.appointmentStatus) {
            filtered = filtered.filter((appointment) => appointment.status === appliedFilters.appointmentStatus);
        }

        if (appliedFilters.visitType) {
            filtered = filtered.filter((appointment) => appointment.visitType === appliedFilters.visitType);
        }

        setFilteredAppointments(filtered);
    };

    const handleFilterSelect = (key, value) => {
        const updatedFilters = { ...filters, [key]: value };
        setFilters(updatedFilters);
        setShowFilters(false);
    };

    const renderFilterOptions = (key) => (
        <div className="filter-options">
            {filterOptions[key].map((option) => (
                <div
                    key={option}
                    className={`filter-option ${filters[key] === option ? 'selected' : ''}`}
                    onClick={() => handleFilterSelect(key, option)}
                >
                    {option}
                </div>
            ))}
        </div>
    );



const handleNavigate = async (patientName, date, timeslot) => {
    try {
        const response = await fetch(`${backendURL}/patients/api/patients`);
        const patientsData = await response.json();
        const patient = patientsData.find((p) => p.name === patientName);
        if (patient) {
            navigateTo('/patientinfo', {
                state: {
                    patientName: patient.name,
                    patientAge: patient.age,
                    patientCondition: patient.type,
                    appointmentDate: date, // Include date
                    appointmentTimeslot: timeslot, // Include timeslot
                },
            });
        } else {
            console.error('Patient not found:', patientName);
        }
    } catch (error) {
        console.error('Error fetching patient data:', error);
    }
};



const handleGroomingClick = async (patientName, groomingProgress, date, timeslot) => {
    try {
        const response = await fetch(`${backendURL}/patients/api/patients`);
        const patientsData = await response.json();
        const patient = patientsData.find((p) => p.name === patientName);
        if (patient) {
            navigate('/grooming', {
                state: {
                    patientName: patient.name,
                    patientAge: patient.age,
                    patientCondition: patient.type,
                    groomingProgress, // Include grooming progress
                    appointmentDate: date, // Include date
                    appointmentTimeslot: timeslot, // Include timeslot
                },
            });
        } else {
            console.error('Patient not found:', patientName);
        }
    } catch (error) {
        console.error('Error fetching patient data:', error);
    }
};


  const navigateTo = (path, state = {}) => {
  navigate(path, { state });
};

    return (
        <div className="dashboard_container appointments_container">
            <div className="navbar_container">
                <div>
                    <h1>Appointments</h1>
                </div>
                <div className="navbar_icon">
                    <div className="navbar_icon_img" onClick={() => setShowFilters(!showFilters)}>
                        <img src={img0} alt="Filter Icon" />
                    </div>
                    <div className="navbar_icon_img">
                        <img src={img1} alt="" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img2} alt="" />
                    </div>
                </div>
            </div>
            <div className="navbar_bottom_line"></div>

            {showFilters && (
                <div className="filters-dropdown">
                    <h3>Appointment Filters</h3>
                    {Object.keys(filters).map((key) => (
                        <div
                            key={key}
                            className="filter-item"
                            onClick={() => setCurrentFilterKey(currentFilterKey === key ? null : key)}
                        >
                            <div className="filter-label">
                                {key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}{' '}
                                ({filters[key] || 'All'}) >
                            </div>
                            {currentFilterKey === key && renderFilterOptions(key)}
                        </div>
                    ))}
                </div>
            )}

            <div className="appointment-cards">
                {filteredAppointments.map((appointment) => (
                    <div key={appointment.id} className="appointment-card" 

                        onClick={() =>
                            handleNavigate(
                                appointment.patientName,
                                appointment.date,
                                appointment.timeslot
                            )
                        }                    
                    >

                        <h3>{appointment.patientName}</h3>
                        <p><strong>Date:</strong> {appointment.date}</p>
                        <p><strong>Time Slot:</strong> {appointment.timeslot}</p>
                        <p><strong>Priority:</strong> {appointment.priority}</p>
                        <p><strong>Type:</strong> {appointment.type}</p>
                        <p><strong>Status:</strong> {appointment.status}</p>
                        <p><strong>Visit Type:</strong> {appointment.visitType}</p>
                        <p><strong>Grooming Completion:</strong> {appointment.groomingProgress}%</p>

{/* Grooming progress bar with stopPropagation */}
<div
    className="grooming-progress-bar"
    onClick={(e) => {
        e.stopPropagation();
          handleGroomingClick(
                appointment.patientName,
                appointment.groomingProgress,
                appointment.date,
                appointment.timeslot
            );
        }}
    style={{
        width: `${appointment.groomingProgress}%`,
        height: "20px",
        background:
            appointment.groomingProgress > 60
                ? "yellow"
                : appointment.groomingProgress === 100
                ? "green"
                : "red",
        cursor: "pointer",
        borderRadius: "5px",
        transition: "width 0.3s ease-in-out",
        position: "relative",
    }}
>
    <span
        style={{
            position: "absolute",
            right: "5px",
            top: "50%",
            transform: "translateY(-50%)",
            fontWeight: "bold",
            color: "black",
        }}
    >
        {appointment.groomingProgress}%
    </span>
</div>


                    </div>
                ))}
            </div>

            <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img14} alt="Patient Icon" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppointmentsPage;

